import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="main-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img 
                  src="/assets/images/Logo_bsb_white.webp" 
                  alt="BSB Fortrade Logo" 
                  className="footer-logo-img"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <h3 style={{ display: 'none' }}>BSB Fortrade</h3>
              </div>
              <p className="footer-tagline">Tech Driven Distribution &amp; Supply Chain Platform</p>
              <div className="social-links">
                <a href="https://www.linkedin.com/company/bsbfortrade" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://www.facebook.com/BSBfortrade" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                <a href="https://www.instagram.com/bsb_polymer_app" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://www.youtube.com/@BSB_Polymer_Trading_App" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
                <a href="https://wa.me/919980989055" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>

              </div>
            </div>
            
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Product</Link></li>
                <li><a href="/#services">Services</a></li>
                <li><Link to="/events">Event</Link></li>
                <li><Link to="/elite-buyer-club">Elite Buyer Club</Link></li>
                <li><Link to="/career">Career</Link></li>
                <li><Link to="/news">News&Blogs</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><a href="/#services">BSB | Polymer</a></li>
                <li><a href="/#services">BSB | Polymer Partner</a></li>
                <li><a href="/#services">BSB | Logistic</a></li>
                <li><a href="/#services">BSB | Finance</a></li>
                <li><a href="/#services">BSB | Global Sourcing</a></li>
                <li><a href="/#services">BSB | Custom</a></li>
                <li><a href="/#services">BSB | Warehouse</a></li>
                <li><a href="/#services">BSB | Shipping</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Contact Us</h4>
              <ul className="contact-info">
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>BSB Fortrade Pvt. Ltd.<br />
                  608-609, Lilamani Corporate Heights,<br />
                  Opp. Ramapir No Tekro BRTS Stand,<br />
                  Near 132ft Ring Road, Nava Vadaj,<br />
                  Ahmedabad-380013, Gujarat, India.</span>
                </li>
                <li><i className="fas fa-phone"></i> <a href="tel:+91279900361">079 29900361</a></li>
                <li><i className="fas fa-envelope"></i> <a href="mailto:info@bsbfortrade.com">info@bsbfortrade.com</a></li>
                <li><i className="fas fa-globe"></i> <a href="https://www.bsbfortrade.com" target="_blank" rel="noopener noreferrer">www.bsbfortrade.com</a></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} BSB Fortrade Private Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
      
      <div className="floating-cta" aria-label="Quick actions">
        <a 
          href="https://wa.me/919980989055?text=Hi%20BSB%20Fortrade%2C%20I%27m%20interested%20in%20your%20services." 
          className="floating-btn whatsapp" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label="Chat on WhatsApp"
        >
          <svg className="whatsapp-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="currentColor"/>
          </svg>
        </a>
      </div>
      
      <div className="mobile-floating-actions">
        <a 
          href="https://wa.me/919980989055?text=Hi%20BSB%20Fortrade%2C%20I%27m%20interested%20in%20your%20services." 
          className="nav-btn btn-whatsapp-nav" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label="Chat on WhatsApp"
        >
          <svg className="whatsapp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="currentColor"/>
          </svg>
        </a>
      </div>
    </>
  );
};

export default Footer;

